<template>
  <div id="organizationStructure">
    <div class="orgLeft" :style="myAutoContent">
      <el-container style="height:100%;width:100%">
        <el-header style="height:auto;margin-top:14px;margin-bottom:1px">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </el-header>
        <el-main style="height:100%;width:100%;">
          <el-tree
            :props="defaultProps"
            node-key="id"
            :data="returnData"
            accordion
            :expand-on-click-node="false"
            ref="tree1"
            @node-click="handleNodeClick"
            :default-expand-all="true"
            :filter-node-method="filterNode"
            :highlight-current="true"
            class="treeClass"
          >
            <!-- :default-expanded-keys="showKeyArray"             v-if="this.platformType==1"-->
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span v-if="data.parent_id == null || data.parent_id==''">
                <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
              </span>
              <span v-else-if="data.type == 1 || data.type=='1'">
                <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
              </span>
              <span v-else>
                <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
              </span>
            </span>
          </el-tree>
        </el-main>
      </el-container>
    </div>

    <div class="orgRight" :style="myAutoContent">
      <!-- 操作栏 -->
      <div class="commonSearch" ref="commonSearchRef">
        <el-form class="el-form el-form--inline" onsubmit="return false">
          <el-form-item label="所属类型">
            <el-select v-model="platformType" placeholder="请选择操作平台" @change="changePlatform">
              <el-option
                v-for="item in operateType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属系统">
            <el-select v-model="systemType" placeholder="请选择系统" clearable @change="changePlatform">
              <el-option
                v-for="item in systemTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="clear:both"></div>
        </el-form>
      </div>
      <div class="commonOperBtn" ref="commonOperBtnRef">
        <el-button type="primary" plain icon="el-icon-edit" @click="openEditDlg('','')">新增</el-button>
        <el-button type="danger" plain icon="el-icon-delete" @click="deleteData">删除</el-button>
      </div>
      <div class="myTable">
        <el-table
          :data="nextChildrenData"
          style="width: 100%"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @select-all="handleSelection"
          element-loading-text="拼命加载中"
          size="medium"
          :height="myTabHeight"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" @selection-change="handleSelectionChange"></el-table-column>
          <el-table-column prop="name" label="功能名称" align="left"></el-table-column>
          <el-table-column prop="url" label="地址" align="left"></el-table-column>
          <el-table-column prop="sort" label="排序" align="left" width="100"></el-table-column>
          <el-table-column prop="type" label="所属平台" align="left" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.type==1">WEB</span>
              <span v-if="scope.row.type==2">APP</span>
            </template>
          </el-table-column>
          <el-table-column prop="disabled" label="是否启用" align="left" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.disabled==0">正常</span>
              <span v-if="scope.row.disabled==1">禁用</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="分属平台" align="left" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.type==1">Web</span>
              <span v-if="scope.row.type==2">App</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <span
                style="cursor:pointer"
                type="primary"
                class="fa fa-edit fa-2x btnColor"
                font-size="10px"
                @click="openEditDlg(scope.$index, scope.row)"
              ></span>
              <span
                style="margin-left:10px;cursor:pointer"
                class="fa fa-times-circle-o fa-2x btnColor"
                @click="deleteById(scope.row.id)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页框 -->
    <div class="commonPage">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[5, 10, 15, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :disabled="loading"
      ></el-pagination>
    </div>

    <div>
      <EditDlg v-if="editDlgShow" ref="editDlgRef"></EditDlg>
    </div>
  </div>
</template>

<script>
let id = 1000;
import SettingApi from "@/api/setting.js";
import OrganizationDlg from "../organizationManage/OrganizationDlg.vue";
import EditDlg from "./MenuManageEditDlg.vue";
import TabResize from "@/utils/TabResizeEx.js";
import HomeApi from "@/api/home.js";
import _ from "lodash";
export default {
  mixins: [TabResize],
  components: {
    OrganizationDlg,
    EditDlg
  },
  mounted: function() {
    //初始化
    this.loading = false;
    this.platformType = "1";
    this.$nextTick(() => {
      this.myAutoContent.height = this.myAutoContentHeight + "px";
      this.myTabHeight = this.myAutoContentInnerHeight + "px";
      this.onloadGroup();
      this.loadSystems();
    });
    if (this.$constant.DEV_MODE) {
      console.log("-- OrganizationStructure addEventListener  resize ---");
    }
    window.addEventListener("resize", this.$mainResize);
  },
  computed: {
    myAutoContentHeight() {
      return this.getMyAutoContentHeight();
    },
    myAutoContentInnerHeight() {
      return this.getMyAutoContentInnerHeight();
    },
    $mainResize() {
      return _.debounce(() => {
        if (this.myAutoContent.height) {
          this.myAutoContent.height = this.getMyAutoContentHeight() + "px";
          this.myTabHeight = this.getMyAutoContentInnerHeight() + "px";
        } else {
          if (this.$constant.DEV_MODE) {
            console.log(" this.myAutoContentHeight 不存在");
          }
        }
      }, 400);
    }
  },
  deactivated() {
    if (this.$constant.DEV_MODE) {
      console.log("-- OrganizationStructure removeEventListener  resize ---");
    }
    window.removeEventListener("resize", this.$mainResize);
  },
  data() {
    return {
      myAutoContent: {
        height: "600px",
        "overflow-y": "auto"
      },
      // 声明保存当前操作的NODE 对象
      currentNode: null,
      currentNodeType: 0,
      currentNodeId: 0,
      myTabHeight: 400,
      defaultProps: {
        children: "subs",
        label: "name",
        isLeaf: "leaf"
      },
      platformType: "",
      filterText: "",
      editDlgShow: false,
      loading: true,
      operateType: [
        {
          value: "1",
          label: "Web"
        },
        {
          value: "2",
          label: "App"
        }
      ],
      systemType: this.$constant.CATALOG,
      systemTypes: [],
      overAllLevel: "",
      returnData: [],
      showKeyArray: [],
      nextChildrenData: [],
      cur_page: 1,
      multipleSelection: [],
      select_word: "",
      parentId: "",
      totalCount: 0,
      per_page: this.$constant.PAGE_SIZE,
      cacheData: {}
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree1.filter(val);
    }
  },
  methods: {
    getMyAutoContentHeight() {
      let defTagsHeight = this.$constant.DEF_TAGS_HEIGHT;
      let defSearchHeight = 0;
      let defHomeHeight = 600;

      if (this.$refs.commonSearchRef) {
        defSearchHeight = this.$refs.commonSearchRef.clientHeight;
      }
      // if (this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef) {
      //   defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
      //     .clientHeight;
      // }

      if (
        this.$parent.$refs.myHomeTagsRef &&
        this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
      ) {
        defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
          .clientHeight;
      }
      defHomeHeight =
        window.innerHeight -
        this.$constant.DEF_HEADER_HEIGHT -
        defTagsHeight -
        this.$constant.DEF_PADDING_HEIGHT -
        defSearchHeight;
      return defHomeHeight;
    },
    getMyAutoContentInnerHeight() {
      let autoContentHeight = this.getMyAutoContentHeight();
      let defHomeHeight = 400;
      let defOperHeight = 47;
      if (this.$refs.commonOperBtnRef) {
        defOperHeight = this.$refs.commonOperBtnRef.clientHeight;
      }
      defHomeHeight = autoContentHeight - defOperHeight;
      return defHomeHeight;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //获取选中行
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelect(selection, row) {
      this.cacheData[this.cur_page] = selection;
    },
    handleSelection(selection) {
      this.cacheData[this.cur_page] = selection;
    },
    initSelect() {
      for (let prop in this.cacheData) {
        if (prop == this.cur_page) {
          if (this.cacheData[prop] && this.cacheData[prop].length > 0) {
            this.$nextTick(() => {
              this.checkIsSelected(this.cacheData[prop]);
            });
          }
        }
      }
    },
    checkIsSelected(selectedData) {
      this.nextChildrenData.forEach(element => {
        selectedData.forEach(el => {
          if (el.id == element.id) {
            this.$refs.multipleTable.toggleRowSelection(element, true);
          }
        });
      });
    },
    onloadGroup() {
      SettingApi.getClass()
        .onloadMenuGroup({
          platformType: this.platformType,
          catalog: this.systemType
        })
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.returnData = res2.data.data;

            // this.showKeyArray = [];
            // this.showKeyArray.push(res2.data.data.id);
            //点击左边树之后this.parentId才会有值
            if (
              this.parentId != "" &&
              this.parentId != null &&
              this.parentId != undefined
            ) {
              this.getListData(this.parentId);
              this.$nextTick(() => {
                this.$refs.tree1.setCurrentKey(this.parentId);
              });
            } else {
              if (res2.data.data != null && res2.data.data.length != 0) {
                //赋值全局type
                this.overAllLevel = res2.data.data[0].level;
                //赋值全局parentId
                this.parentId = res2.data.data[0].id;
                this.parentName = res2.data.data[0].name;
                this.currentNodeType = res2.data.data[0].type;
                this.currentNodeId = res2.data.data[0].id;

                this.$nextTick(() => {
                  this.$refs.tree1.setCurrentKey(this.parentId);
                });
                this.getListData(this.parentId);
              }
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    getListData(id) {
      this.loading = true;
      SettingApi.getClass()
        .getMenuListData({
          id: id,
          pageNum: this.cur_page,
          pageSize: this.per_page,
          type: this.platformType,
          keyword: this.select_word,
          catalog: this.systemType
        })
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.totalCount = res2.data.data.totalElements;
            this.nextChildrenData = res2.data.data.data;
            this.initSelect();
            this.loading = false;
          } else {
            this.$message.error(res2.data.msg);
            this.loading = false;
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    handleSizeChange(val) {
      this.per_page = val;
      this.cur_page = 1;
      this.loading = true;
      this.getListData(this.parentId);
    },
    // 切换显示第几页
    handleCurrentChange(val) {
      this.cur_page = val;
      this.loading = true;
      this.getListData(this.parentId);
    },
    handleNodeClick(data, node, vuecomponent) {
      // console.log(
      //   "data:",
      //   data,
      //   "\n",
      //   "node:",
      //   node,
      //   "\n",
      //   "vuecomponent",
      //   vuecomponent
      // );
      this.parentId = data.id;
      this.parentName = data.name;
      this.overAllLevel = data.level;
      this.getListData(data.id);
    },
    openEditDlg(index, row) {
      this.editDlgShow = true;
      let operateFlag = "";
      let param = {
        parentId: this.parentId,
        parentName: this.parentName
      };
      if (row != null && row != "") {
        operateFlag = "update";
        this.$nextTick(() => {
          this.$refs.editDlgRef.init(
            param,
            row,
            operateFlag,
            this.platformType,
            this.systemType
          );
        });
      } else {
        operateFlag = "add";
        this.$nextTick(() => {
          this.$refs.editDlgRef.init(
            param,
            "",
            operateFlag,
            this.platformType,
            this.systemType
          );
        });
      }
    },
    deleteData() {
      let idList = new Array();
      if (this.multipleSelection.length == 0) {
        this.$message.error("请至少选择一条要删除的数据！");
        return false;
      }
      //遍历选中的checkbox数据集合 拿出其中的ids
      for (let i = 0; i < this.multipleSelection.length; i++) {
        idList.push("" + this.multipleSelection[i]["id"]);
      }
      let param = {
        ids: idList
      };
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          // this.$mhttp.httpPost(
          //   this.$constant.API_NSC + "uc/menu/del/multiple",
          //   param,
          //   "application/json"
          // );
          this.loading = true;
          SettingApi.getClass()
            .deleteMenuById(param)
            .then(res2 => {
              if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                this.$message.success("删除成功！");
                this.refreshData();
                this.cacheData[this.cur_page] = {};
                this.loading = false;
              } else {
                this.$message.error(res2.data.msg);
                this.loading = false;
                return false;
              }
            })
            .catch(err => {
              this.$message.error(err);
              this.loading = false;
              return false;
            });
        })
        .catch(() => {});
    },
    deleteById(id) {
      let idList = new Array();
      idList.push(id);
      let param = {
        ids: idList
      };
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.loading = true;
          SettingApi.getClass()
            .deleteMenuById(param)
            .then(res2 => {
              if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                this.$message.success("删除成功！");
                this.refreshData();
                this.cacheData[this.cur_page] = {};
                this.loading = false;
              } else {
                this.$message.error(res2.data.msg);
                this.loading = false;
                return false;
              }
            })
            .catch(err => {
              this.$message.error(err);
              this.loading = false;
              return false;
            });
        })
        .catch(() => {});
    },
    changePlatform() {
      this.onloadGroup();
    },
    loadSystems() {
      SettingApi.getClass()
        .loadSystems()
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            this.systemTypes = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    refreshData() {
      let length = this.multipleSelection.length;
      if (length == null || length == "") {
        length = 1;
      }
      let m = Math.ceil((this.totalCount - length) / this.per_page);
      if (this.cur_page > 1 && this.cur_page > m) {
        this.cur_page = this.cur_page - 1;
      }
      this.onloadGroup();
      this.getListData(this.parentId);
    }
    
  }
 
};
</script>


<style lang="stylus" scoped>
#organizationStructure {
  width: 100%;

  .orgLeft {
    width: 250px;
    float: left;
    margin-left: $content-margin-left;
    background-color: white;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
  }

  .orgRight {
    margin-top: $content-margin-top;
    margin-right: $content-margin-right;
    background-color: white;
    width: auto;
    margin-left: 260px;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
  }

  .custom-tree-node {
    font-size: $default-font;
  }

  .btnColor {
    color: $theme-color;
  }

  .treeClass >>> .el-tree-node__children {
    overflow: inherit !important;
  }

  .treeClass >>> .el-tree-node__content {
    width: 100%;
  }
}
</style>

